import { useState } from "react";
import { Button, Input } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@altimateai/lego";

interface RunNameModalProps {
  onClose: () => void;
  onSubmit: (runName: string, defaultName: string) => void;
  selectedCount: number;
}

export const RunNameModal: React.FC<RunNameModalProps> = ({ onClose, onSubmit, selectedCount }) => {
  const [runName, setRunName] = useState("");

  // Generate default run name: username + timestamp
  const now = new Date();
  const defaultName = `Run ${now.toLocaleDateString()} ${now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;

  const handleSubmit = () => {
    onSubmit(runName, defaultName);
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="al-max-w-md">
        <DialogHeader>
          <DialogTitle>Run Selected Test Cases</DialogTitle>
        </DialogHeader>

        <Stack direction="column" gap="md" className="al-mt-4">
          <div className="al-text-sm al-text-gray-600">
            You are about to run <span className="al-font-semibold">{selectedCount}</span> test case
            {selectedCount !== 1 ? "s" : ""}.
          </div>

          <div>
            <div className="al-text-sm al-font-semibold al-mb-2">Run Name</div>
            <Input
              id="run-name-input"
              type="text"
              className="al-mt-2"
              value={runName}
              onChange={e => setRunName(e.target.value)}
              placeholder={defaultName}
              autoFocus
            />
            <div className="al-text-xs al-text-gray-500 al-mt-1">
              Leave empty to use default: &quot;{defaultName}&quot;
            </div>
          </div>
        </Stack>

        <DialogFooter className="al-mt-4">
          <Button onClick={onClose} variant="outline" size="sm">
            Cancel
          </Button>
          <Button size="sm" onClick={handleSubmit}>
            Run {selectedCount} Test{selectedCount !== 1 ? "s" : ""}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
